var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBookCall = function SvgBookCall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#4FC86F",
    fillOpacity: 0.3,
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#4FC86F",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.333,
    d: "M13.222 15.045a.67.67 0 0 0 .808-.202l.237-.31A1.33 1.33 0 0 1 15.334 14h2a1.333 1.333 0 0 1 1.333 1.333v2a1.333 1.333 0 0 1-1.334 1.334 12 12 0 0 1-12-12 1.333 1.333 0 0 1 1.334-1.334h2A1.333 1.333 0 0 1 10 6.667v2a1.33 1.33 0 0 1-.533 1.066l-.312.234a.67.67 0 0 0-.195.822 9.33 9.33 0 0 0 4.262 4.256"
  })));
};
export default SvgBookCall;